/* Options:
Date: 2018-11-14 04:06:04
Version: 5.20
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://api.messagehub.ca

//GlobalNamespace:
//MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/

export interface Channel
{
    id: string;
    name: string;
    description: string;
    creator: number;
    creatorInitials: string;
    creatorName: string;
    userIds: number[];
    color: number;
    public: boolean;
    archived: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface Post
{
    id: string;
    content: string;
    creator: number;
    creatorInitials: string;
    creatorName: string;
    topicId: string;
    channelId: string;
    attachments: AttachmentSummary[];
    recipients: number[];
    isDeleted: boolean;
    systemMessage: string;
    postedAt: string;
    lastEditedAt: string;
}
export interface GetAttachmentResponse {
    downloadUrl: string
}
export class GetAttachment{
    id: string
    constructor(id: string){
        this.id = id
    }
}
export interface Topic
{
    id: string;
    isDraft: boolean;
    title: string;
    content: string;
    starred: boolean;
    creator: number;
    creatorInitials: string;
    creatorName: string;
    channelId: string;
    attachments: string[];
    participants: number[];
    commentCount: number;
    lastObjIndex: string;
    snippet: string;
    snippetCreator: number;
    lastUpdatedAt: string;
    systemMessage: string;
    postedAt: string;
    lastEditedAt: string;
    createdAt: string;
}
export interface GetChannelsResponse
{
    data: Channel[];
}

export interface CreateOrUpdateChannelResponse
{
    data: Channel;
}

export interface GetEmailContentResponse
{
    content: string[];
}


export interface GetPostResponse
{
    data: Post[];
}

export interface CreateOrUpdatePostResponse
{
    data: Post;
}

export interface GetTopicResponse
{
    data: Topic[];
}

export interface CreateOrUpdateTopicResponse
{
    data: Topic;
}

export class WhoAmIUserResponse
{
}

export interface GetChannels
{
    id: string;
}

// @Route("/channel", "POST")
export class CreateChannel
{
    constructor(name: string, description: string, isPublic: boolean) {
        this.name = name
        this.description = description
        this.public = isPublic
    }

    // @ApiMember(IsRequired=true)
    public name: string;

    // @ApiMember(IsRequired=true)
    public description: string;

    // @ApiMember(IsRequired=true)
    public userIds?: number[];

    // @ApiMember(IsRequired=true)
    public color?: string;

    // @ApiMember(IsRequired=true)
    public public: boolean;

}

// @Route("/channel", "PUT")
// @DataContract

/*
export class UpdateChannel
{
    // @DataMember(Name="id")
    public id: string;

    // @DataMember(Name="name")
    public name: string;

    // @DataMember(Name="description")
    public description: string;

    // @DataMember(Name="user_ids")
    public userIds: number[];

    // @DataMember(Name="color")
    public color: number;

    // @DataMember(Name="public")
    public public: boolean;

    // @DataMember(Name="archived")
    public archived: boolean;
}
*/
// @Route("/channel", "DELETE")
export class DeleteChannel
{
    public id: string;
    constructor(id: string){
        this.id = id
    }
}


// @Route("/topicpost", "GET")
export class GetPost
{
    constructor(id: string){
        this.id = id
    }
    public id: string;
}

// @Route("/topicpost/topic", "GET")
export class GetPostByTopicId
{
    constructor(id: string){
        this.id = id
    }
    public id: string;
}

export class CreateAttachment{
    name: string
    filename: string
    isMultipart: boolean
    contentType: string
    hash: string
    fileSize: number
    entity: EntityInformation
    constructor(name: string, filename: string, isMultipart: boolean,
                contentType: string, hash: string, fileSize: number,
                entity: EntityInformation){
        this.name =  name;
        this.filename = filename;
        this.isMultipart = isMultipart;
        this.contentType= contentType;
        this.hash = hash;
        this.fileSize = fileSize;
        this.entity = entity
    }
}
export class EntityInformation
{
    id: string
    entity: EntityType

    constructor(id: string, entity: EntityType) {
        this.id = id;
        this.entity = entity;

    }


}
export interface LatestAttachmentVersion{
    id: string
    putUrl: string
    putHeaders: PutHeaders[]

}
export interface PutHeaders{
    name: string
    value: string
}
export interface CreateAttachmentResponse{
    id: string
    latestAttachmentVersion: LatestAttachmentVersion
}
export class FileUploadList{
    public fileName: string
    public percentageCompleted: number
    constructor(fileName: string, percentageComplete: number){
        this.fileName = fileName;
        this.percentageCompleted = percentageComplete
    }
}
export enum EntityType
{
    Channel,
    Topic,
    Post,
    Attachment
}
export class FinalizeAttachmentUpload{
    id: string
    uuid: string
    versionId: string;
    fullyUploaded: boolean
    receivedAt: string
    constructor(id: string, uuid: string, fullyUploaded: boolean,
                versionId: string, receivedAt: string){
        this.id = id;
        this.uuid = uuid;
        this.fullyUploaded = fullyUploaded;
        this.versionId = versionId
        this.receivedAt = receivedAt
    }
}
export class CreatePost
{
    constructor(content: string, topicId: string, channelId: string){
        this.content = content
        this.topicId = topicId
        this.channelId = channelId
    }
    public content: string;
    public topicId: string;
    public channelId: string;
}
export interface FinalizeAttachmentUploadResponse {
    id: string
    name: string
    attachmentVersion: AttachmentVersion
}
export interface AttachmentVersion {
    id: string
    attachmentId: string
    createdAt: Date
    updatedAt: Date
    filename: string
    version: AttachmentKey,
    size?: number
    versionNumber: number,
    contentType: string,
    receivedAt?: Date
    putUrl: string,
    fullyUploaded: boolean
}
export interface AttachmentKey {
    key: string
    versionId: string
}
export class AttachmentSummary {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }

}
export class UpdatePost
{
    constructor(id: string, content: string, isDraft?: boolean)
    {
        this.id = id
        this.content = content
        if (isDraft!=null){
            this.isDraft = isDraft
        }
    }
    public id: string;
    public content: string;
    public isDraft: boolean = false;
    public attachments?: AttachmentSummary[];
    public recipients?: number[];
    public isDeleted?: boolean;
    public lastEditedAt?: string;
}

export class DeletePost
{
    constructor(id: string){
        this.id = id
    }
    public id: string;
}

// @Route("/topic", "GET")
export class GetTopic
{
    constructor(id: string){
        this.id = id
    }
    public id: string;

}

export class GetTopicsInChannel
{
    constructor(id: string){
        this.id = id
    }
    public id: string;

}

export class CreateTopic
{
    constructor(title: string, isDraft: boolean, channelId:string){
        this.title = title
        this.isDraft = isDraft
        this.channelId = channelId
    }
    public title: string;
    public isDraft: boolean;
    public channelId: string;
}

// @Route("/topic", "PUT")
export class UpdateTopic
{
    constructor(isDraft:boolean, id:string, title: string, content: string, starred?:boolean,
                attachments?:string[], participants?: number[]){
        this.isDraft = isDraft;
        this.id = id;
        this.title = title;
        this.content = content;
        if (starred == undefined){
            this.starred = false;
        }else{
            this.starred = starred
        }
        if (attachments == undefined){
            this.attachments = [];
        }
        else{
            this.attachments = attachments;
        }
        if (participants == undefined){
            this.participants = []
        }else{
            this.participants = participants
        }
    }
    public isDraft: boolean;
    public id: string;
    public title: string;
    public content: string;
    public starred: boolean;
    public attachments: string[];
    public participants: number[];

}

// @Route("/topic", "DELETE")
export class DeleteTopic
{
    public id: string;
    constructor(id: string){
        this.id = id
    }
}

